'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _zh_TW = require('../../date-picker/locale/zh_TW');

var _zh_TW2 = _interopRequireDefault(_zh_TW);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _zh_TW2['default'];